import { memo } from 'react';

import AuthPageHeader from './AuthPageHeader';

const OnboardingPageLayout = memo(({ children }) => (
  <div className="flex min-h-dvh w-full flex-col bg-merchant-bg-subtle">
    <AuthPageHeader />
    <main className="flex flex-1 flex-col items-center px-page py-page">
      <div className="flex w-full max-w-onboarding flex-1 flex-col gap-page">{children}</div>
    </main>
  </div>
));

OnboardingPageLayout.displayName = 'OnboardingPageLayout';

export default OnboardingPageLayout;
